// src/components/DemoPlaceholder.tsx
import React from "react";
import type { ActivePlan } from "../lib/getFeatureMode";

function getCtaLine(plan: ActivePlan) {
  if (plan === "STARTER") {
    return "Upgrade to Growth or Insight plan to generate this for your own chart.";
  }
  if (plan === "GROWTH") {
    return "Upgrade to Insight plan to unlock this section.";
  }
  if (plan === "PREMIUM_UNLOCK") {
    return "This section is available in the Insight plan.";
  }
  return "Upgrade to unlock this section.";
}

function getSectionTitle(tabLabel?: string) {
  if (tabLabel) return `🔒 ${tabLabel}`;
  return "🔒 Section Preview";
}

export default function DemoPlaceholder({
  plan,
  tabLabel,
}: {
  plan: ActivePlan;
  tabLabel?: string;
}) {
  return (
    <div
      style={{
        padding: 20,
        borderRadius: 14,
        background: "rgba(255,255,255,0.02)",
        border: "1px solid rgba(148,163,184,0.15)",
      }}
    >
      {/* Section label — matches "Interpretive Depth" style exactly */}
      <div
        style={{
          fontSize: 11,
          letterSpacing: 0.8,
          textTransform: "uppercase",
          color: "#64748b",
          marginBottom: 10,
        }}
      >
        Locked Section
      </div>

      {/* Title */}
      <div style={{ fontWeight: 600, marginBottom: 8 }}>
        {getSectionTitle(tabLabel)}
      </div>

      {/* Body */}
      <div style={{ fontSize: 13, color: "#cbd5e1", lineHeight: 1.7 }}>
        Your chart has been calculated — this section is not included in the
        Starter plan.
        <br />
        Unlock to view this analysis for{" "}
        <strong style={{ color: "#e2e8f0" }}>your own birth chart</strong>.
        <br />
        <br />
        <span style={{ color: "rgba(251,191,36,0.75)" }}>
          {getCtaLine(plan)}
        </span>
      </div>
    </div>
  );
}
